/**
 * @generated SignedSource<<3a4235672173702b4a9eb1179702d564>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type personalizedNotificationTemplateEdit_PersonalizedNotificationTemplateFragment$data = {
  readonly id: string;
  readonly template: {
    readonly key: string;
    readonly message: string;
    readonly title: string;
    readonly variables: ReadonlyArray<string>;
  };
  readonly " $fragmentType": "personalizedNotificationTemplateEdit_PersonalizedNotificationTemplateFragment";
};
export type personalizedNotificationTemplateEdit_PersonalizedNotificationTemplateFragment$key = {
  readonly " $data"?: personalizedNotificationTemplateEdit_PersonalizedNotificationTemplateFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"personalizedNotificationTemplateEdit_PersonalizedNotificationTemplateFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "personalizedNotificationTemplateEdit_PersonalizedNotificationTemplateFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NotificationTemplate",
      "kind": "LinkedField",
      "name": "template",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "variables",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PersonalizedNotificationTemplate",
  "abstractKey": null
};

(node as any).hash = "5cd85b925a0811cf60bedc8a8926a743";

export default node;
